import React, { useEffect, useMemo } from 'react';
import { SDKResponse } from '@commercetools/frontend-sdk';
import { PageResponse } from '@commercetools/frontend-sdk/lib/types/api/page';
import { isDebugEnabled } from 'helpers/utils/debug';

const TracingProvider = ({ children, page }: React.PropsWithChildren<{ page: SDKResponse<PageResponse> }>) => {
  const { frontasticRequestId } = page.tracing;

  const data = useMemo(() => (page.isError ? null : page.data), [page]);

  useEffect(() => {
    if (!isDebugEnabled()) return;
    console.log(`%cFrontastic-Request-ID: ${frontasticRequestId}`, 'font-size: 16px;');
  }, [frontasticRequestId]);

  useEffect(() => {
    if (!data || !isDebugEnabled()) return;

    console.log('Datasources:', data.data.dataSources);
    console.log('Studio:', { page: data.page, pageFolder: data.pageFolder });
  }, [data]);

  return <>{children}</>;
};

export default TracingProvider;
